// Shared across every section-complete screen — only the text and points
// values differ per section, the confetti illustration stays the same.
export { default as sectionCompleteConfettiPNG } from '~/assets/images/anatomyV2/section-complete-confetti.png'
export { default as sectionCompleteConfettiWEBP } from '~/assets/images/anatomyV2/section-complete-confetti.webp'

export const SECTION_COMPLETE_PROGRESS_COLOR = '#8C67F6'
export const AUTO_ADVANCE_DELAY_MS = 2000

export interface IConfettiPiece {
  left: number
  color: string
  delay: number
  duration: number
  rotation: number
}

const CONFETTI_PIECE_COUNT = 16
const CONFETTI_COLOR_PALETTE = [
  '#7B5CFA',
  '#8C67F6',
  '#33C558',
  '#6E68EE',
  '#FFC107',
  '#FF6B81',
]

export const CONFETTI_FALL_DISTANCE_PX = 420

export const CONFETTI_PIECES: IConfettiPiece[] = Array.from(
  { length: CONFETTI_PIECE_COUNT },
  (_, index) => ({
    left: (index * 6.25 + (index % 3) * 2) % 100,
    color: CONFETTI_COLOR_PALETTE[index % CONFETTI_COLOR_PALETTE.length],
    delay: (index % 5) * 0.1,
    duration: 1.7 + (index % 4) * 0.15,
    rotation: (index * 47) % 360,
  }),
)
